import { uiMutations } from './mutations/ui'
import { systemMutations } from './mutations/system'
import { userMutations } from './mutations/users'
import { groupMutations } from './mutations/groups'
import { catalogMutations } from './mutations/catalog'
import { trainingMutations } from './mutations/trainings'
import { contentMutations } from './mutations/content'
import { mediaMutations } from './mutations/media'
import { boosterMutations } from './mutations/boosters'
import { orderMutations } from './mutations/orders'
import { promotionMutations } from './mutations/promotions'
import { miscMutations } from './mutations/misc'
import { commonMutations } from './mutations/common'

const mutations = {
  ...uiMutations,
  ...systemMutations,
  ...userMutations,
  ...groupMutations,
  ...catalogMutations,
  ...trainingMutations,
  ...contentMutations,
  ...mediaMutations,
  ...boosterMutations,
  ...orderMutations,
  ...promotionMutations,
  ...miscMutations,
  ...commonMutations
}

export { mutations }
